export interface DisplayTypesOption {
  label?: string;
  value: DisplayOptions;
}

export enum DisplayOptions {
  data = 'Data',
  feature = 'Feature',
  overview = 'Overview',
  trends = 'Trends',
}
